import { Form } from '@kanda-libs/ks-component-ts';

import { Details } from 'pages/CreateJob/components';
import {
  Field,
  SearchHeader,
  SearchResults,
  SelectCustomer,
} from './components';

import { SEARCH_HEADER_PROPS } from './Customer-constants';
import Container from './Customer-container';

import { Page } from '../..';

const ViewComponent = () => (
  <Container>
    {({
      form,
      onSubmit,
      isLoading,
      showSearchBar,
      showResults,
      nextButtonProps,
      searchProps,
      headerProps,
      searchResultsProps,
    }) => (
      <Form
        id="create-job-customer-mobile"
        form={form}
        onSubmit={onSubmit}
        isLoading={isLoading}
      >
        <Page
          stickyHeader
          nextButtonProps={nextButtonProps}
          layoutProps={
            showResults
              ? {
                  ...SEARCH_HEADER_PROPS,
                  header: <SearchHeader {...headerProps} />,
                }
              : {}
          }
        >
          {showResults ? (
            <SearchResults {...searchResultsProps} />
          ) : (
            <>
              <Field.Wrapper>
                <Details.ChangesBanner footer={<div className="mb-6" />} />
                {showSearchBar && <SelectCustomer {...searchProps} />}
                <span className="text-16-24-em text-neutral-900">
                  Customer Contact Details
                </span>
                <div className="mt-3" />
                <Field.Name />
                <Field.Contact />
                <Field.Address />
              </Field.Wrapper>
            </>
          )}
        </Page>
      </Form>
    )}
  </Container>
);
ViewComponent.displayName = 'CreateJob-Customer-Mobile-view';

export default ViewComponent;
